<script setup lang="ts">
/**
 * Main navigation links (public mode).
 */
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'

const route = useRoute()
const { t } = useI18n()
</script>

<template>
  <nav class="flex items-center gap-2 max-md:hidden">
    <template
      v-for="link in [
        { to: '/pricing', labelKey: 'nav.pricing', external: false },
        { to: '/blog', labelKey: 'nav.blog', external: true },
        { to: '/terms', labelKey: 'nav.terms', external: false },
        { to: '/privacy', labelKey: 'nav.privacy', external: false },
        { to: '/refund', labelKey: 'nav.refund', external: false },
      ]"
      :key="link.to"
    >
      <a
        v-if="link.external"
        :href="link.to"
        :class="[
          'px-4 py-2 text-sm font-medium rounded-md transition-all duration-200 no-underline',
          route.path.startsWith(link.to)
            ? 'text-brand bg-brand/10'
            : 'text-foreground-secondary hover:text-foreground hover:bg-surface-tertiary',
        ]"
      >
        {{ t(link.labelKey) }}
      </a>
      <RouterLink
        v-else
        :to="link.to"
        :class="[
          'px-4 py-2 text-sm font-medium rounded-md transition-all duration-200 no-underline',
          route.path === link.to
            ? 'text-brand bg-brand/10'
            : 'text-foreground-secondary hover:text-foreground hover:bg-surface-tertiary',
        ]"
      >
        {{ t(link.labelKey) }}
      </RouterLink>
    </template>
  </nav>
</template>
